import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import InfoTip from './InfoTip';

export default function DashboardSection({ id, title, children }) {
    return (
        <Box id={id} sx={{ mb: 4, scrollMarginTop: '120px' }}>
            <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {children}
        </Box>
    );
}

export function ChartTitle({ children, tooltip }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
            <Typography variant="subtitle2">
                {children}
            </Typography>
            {tooltip && <InfoTip text={tooltip} size={16} />}
        </Box>
    );
}
